$(document).ready(function() {

  // Advanced search toggle
  $('.advanced-search-button').on('click', function() {
    $advancedSearch = $('.advanced-search');
    if ($advancedSearch.height() == 0) {
      if ($(window).width() <= 480) { 
        $('.advanced-search').css('height', '100%');
      } else {
        $('.advanced-search').css('height', '95px');
      }
    } else {
      $('.advanced-search').css('height', 0);
    }
  });

  // Clear search field when clicking X
  $('.search-field .icon-x_button').on('click', function() {
    $('.search').val('');
  });

  // Set hidden inputs values (the dropdowns are outside the form), and then submit the form
  $('[name=order_dropdown]').on('change', function() {
    $('[name=order]').val($(this).val());
    $('.search-form.inline').submit();
  });
  $('[name=orderby_dropdown]').on('change', function() {
    $('[name=orderby]').val($(this).val());
    $('.search-form.inline').submit();
  });

});
